import { coreApi } from '$api'
import {
  CompanyDefaultWorkingHours,
  ICompanyDefaultWorkingHours,
  IKeyValueBindingModel,
  KeyValueBindingModel,
} from '$models'
import { singletonQueryClient } from '$utils'

enum QueryKeys {
  CompanyDefaultWorkingHours = 'company-default-working-hours',
}

/**
 * Get all company default working hours
 * @returns Promise<CompanyDefaultWorkingHours[]>
 */
export const getCompanyDefaultWorkingHours = (): Promise<
  ICompanyDefaultWorkingHours[]
> => {
  return singletonQueryClient.fetchQuery({
    queryKey: [QueryKeys.CompanyDefaultWorkingHours],
    queryFn: async () => {
      return coreApi.getCompanyDefaultWorkingHours()
    },
  })
}

/**
 * Update all company default working hours
 * @returns Promise<ICompanyDefaultWorkingHours[]>
 */
export const updateCompanyDefaultWorkingHours = (
  companyDefaultWorkingHours: ICompanyDefaultWorkingHours[]
): Promise<ICompanyDefaultWorkingHours[]> => {
  return coreApi.updateCompanyDefaultWorkingHours(
    companyDefaultWorkingHours as CompanyDefaultWorkingHours[]
  )
}

/**
 * Update company preferences via key/value pairs
 */
export const updateCompanyPreferences = (
  preferences: IKeyValueBindingModel[]
): Promise<IKeyValueBindingModel[]> => {
  return coreApi.setCompanyPreferences(preferences as KeyValueBindingModel[])
}
